export default class PopUp {
  constructor() {
    this.popUp = document.querySelector("[data-pop-up]");
    if (!this.popUp) return;
    this.buttonContainer = document.querySelector("[data-pop-up-container]");
    this.openButton = document.querySelector("[data-pop-up-open]");
    this.closeButton = document.querySelector("[data-pop-up-close]");
    this.searchContainer = document.querySelector(
      "[data-pop-up-search-container]",
    );
    this.chatButton = document.querySelector("[data-pop-up-chat]");
    this.chatContainer = document.querySelector("[data-pop-up-chat-container]");
    this.openMessageButton = document.querySelector(
      "[data-pop-up-send-message]",
    );
    this.messageContainer = document.querySelector(
      "[data-pop-up-message-container]",
    );
    this.chatCloseButton = document.querySelector("[data-pop-up-chat-close]");
    this.chatBackButton = document.querySelector("[data-pop-up-chat-back]");

    this.handleOpenClick();
    this.handleCloseClick();
    this.handleChatCloseClick();
    this.handleChatClick();
    this.handleSendMessageClick();
    this.handleChatBackClick();
    // this.togglePopUp();
    this.handleButtonOpenClick();
  }

  togglePopUp() {
    const frontPage = document.querySelector("body.page-start");
    if (!frontPage) {
      this.popUp.classList.add("show");
      return;
    }

    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        this.popUp.classList.add("show");
      } else {
        this.popUp.classList.remove("show");
      }
    });
  }

  handleOpenClick() {
    this.openButton.addEventListener("click", () => {
      this.popUp.classList.toggle("button-container-open");
      this.popUp.classList.toggle("search-container-open");
    });
  }

  handleCloseClick() {
    this.closeButton.addEventListener("click", () => {
      this.popUp.classList.remove("button-container-open");
      this.popUp.classList.remove("search-container-open");
    });
  }

  handleChatClick() {
    this.chatButton.addEventListener("click", () => {
      const isOpen = this.popUp.classList.contains("chat-container-open");
      if (!isOpen) {
        this.popUp.classList.add("chat-container-open");
        this.popUp.classList.remove("search-container-open");
      }
    });
  }

  handleSendMessageClick() {
    this.openMessageButton.addEventListener("click", () => {
      this.popUp.classList.add("message-container-open");
      this.openMessageButton.classList.toggle("d-none");
    });
  }

  handleChatCloseClick() {
    this.chatCloseButton.addEventListener("click", () => {
      this.popUp.classList.remove("message-container-open");
      this.popUp.classList.remove("chat-container-open");
      this.openMessageButton.classList.remove("d-none");
      this.popUp.classList.add("search-container-open");
    });
  }

  handleChatBackClick() {
    this.chatBackButton.addEventListener("click", () => {
      this.popUp.classList.remove("message-container-open");
      this.openMessageButton.classList.remove("d-none");
    });
  }

  handleButtonOpenClick() {
    const buttons = document.querySelectorAll(".o-button--send-message");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const isOpen = this.popUp.classList.contains("chat-container-open");
        if (!isOpen) {
          this.popUp.classList.toggle("button-container-open");
          this.popUp.classList.toggle("search-container-open");

          this.popUp.classList.add("chat-container-open");
          this.popUp.classList.remove("search-container-open");
        }
      });
    });
  }
}
